import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: '首页', path: '/' },
    { name: '海内外求职', path: '/job' },
    { name: '+留学申请', path: '/study' },
    { name: '+移民规划', path: '/immigration' },
  ];

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <h1 className="text-2xl text-blue-600">
              <span className="font-black" style={{ fontFamily: '"SimHei", "Microsoft YaHei", sans-serif' }}>逐梦教育</span>
              <span className="font-bold ml-2" style={{ fontFamily: '"Dancing Script", cursive' }}>BD Careers</span>
            </h1>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === item.path ? 'text-blue-600' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/#assessment"
              className="bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
            >
              免费评估
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden w-6 h-6 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-100">
            <div className="flex flex-col space-y-3 pt-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer ${
                    location.pathname === item.path ? 'text-blue-600' : ''
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <Link
                to="/#assessment"
                className="bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700 transition-colors font-medium text-center whitespace-nowrap cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                免费评估
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
